import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/auth/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const ProductCategoryPage = lazy(() => import('../pages/product-category/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const BPC157LandingPage = lazy(() => import('../pages/product/bpc-157/page'));
const MOTSCLandingPage = lazy(() => import('../pages/product/mots-c/page'));
const TB500LandingPage = lazy(() => import('../pages/product/tb-500/page'));
const GHKCuLandingPage = lazy(() => import('../pages/product/ghk-cu/page'));
const KPVLandingPage = lazy(() => import('../pages/product/kpv/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const HowToOrderPage = lazy(() => import('../pages/how-to-order/page'));
const QualityPage = lazy(() => import('../pages/quality/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const ForgotPasswordPage = lazy(() => import('../pages/forgot-password/page'));
const ResetPasswordPage = lazy(() => import('../pages/reset-password/page'));
const AccountPage = lazy(() => import('../pages/account/page'));
const RequestsPage = lazy(() => import('../pages/account/requests/page'));
const AccountOrdersPage = lazy(() => import('../pages/account/orders/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminOrdersPage = lazy(() => import('../pages/admin/orders/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/category/:categorySlug',
    element: <ProductCategoryPage />,
  },
  {
    path: '/product/bpc-157',
    element: <BPC157LandingPage />,
  },
  {
    path: '/product/mots-c',
    element: <MOTSCLandingPage />,
  },
  {
    path: '/product/tb-500',
    element: <TB500LandingPage />,
  },
  {
    path: '/product/ghk-cu',
    element: <GHKCuLandingPage />,
  },
  {
    path: '/product/kpv',
    element: <KPVLandingPage />,
  },
  {
    path: '/product/:productSlug',
    element: <ProductDetailPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/how-to-order',
    element: <HowToOrderPage />,
  },
  {
    path: '/quality',
    element: <QualityPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/account',
    element: (
      <ProtectedRoute>
        <AccountPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/account/requests',
    element: (
      <ProtectedRoute>
        <RequestsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/account/orders',
    element: (
      <ProtectedRoute>
        <AccountOrdersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute>
        <AdminPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/orders',
    element: (
      <ProtectedRoute>
        <AdminOrdersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
